import React from 'react';
import {Provider} from 'react-redux'
import { Router, Location } from '@reach/router'
import store from './redux/store'
import LandingRoute from './routes/Landing'
import MapsRoute from "./routes/Maps";
import FirebaseProvider from "./redux/firebaseProvider";
import changes from "./redux/changesDuck";
//
// if (process.env.NODE_ENV !== "production") {
//   const whyDidYouRender = require("@welldone-software/why-did-you-render");
//
//   whyDidYouRender(React, {
//     onlyLogs: true,
//     collapseGroups: true,
//     titleColor: "green",
//     diffNameColor: "darkturquoise",
//     include: [/.*/],
//     // Reduce noise from react-router components
//     // https://github.com/welldone-software/why-did-you-render/issues/27#issuecomment-495715263
//     exclude: [/^Link/, /^Route/, /^BrowserRouter/, /^Draw/],
//   });
// }

function App() {


  return (

      <Provider store={store}>
      <FirebaseProvider store={store}>

      <Location>
        {props => {
          // Add vertical scroll to all routes but mapping routes
          const { location: { pathname } } = props;
          const style = pathname === '/map' ? {} : { overflowY: 'scroll' };
          return (
            <Router style={style} >
              <LandingRoute path='/' style={{ overflowY: 'scroll' }} />
              <MapsRoute path='maps/*' />
              <LandingRoute default />
            </Router>
          )}}

        </Location>
      </FirebaseProvider>
      </Provider>
  );

}

export default App;



// WEBPACK FOOTER //
// ./src/App.js